import {
  useContractExtractionResult,
  useEnableContractExtraction,
  useSetContractId
} from 'ContractExtraction/index'
import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'
import { AUTO_DISPLAY_CONTRACT_ATTACHMENT_QUERY_PARAM_KEY } from 'Cube/view/layouts/billingSchedule/BillingScheduleInspector/useAutoDisplayContractAttachment'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

type UseContractExtractionConnector = () => undefined

export const useContractExtractionConnector: UseContractExtractionConnector =
  () => {
    const flags = useFlags()
    const navigate = useNavigate()
    const cubeContext = useCubeContext()

    const setContractId = useSetContractId()
    const extractionResult = useContractExtractionResult()
    const enableContractExtraction = useEnableContractExtraction()

    /**
     * Disable performing contract extraction if not allowed by Cube
     */
    useEffect(() => {
      enableContractExtraction(
        cubeContext.queries.availableFeatures.common.contractExtraction
          .available.enabled
      )
    }, [
      cubeContext.queries.availableFeatures.common.contractExtraction,
      enableContractExtraction
    ])

    useEffect(() => {
      setContractId(cubeContext.queries.rawData.data.schedule.contractId)
    }, [cubeContext.queries.rawData.data.schedule.contractId, setContractId])

    useEffect(() => {
      if (!extractionResult || !flags?.useContractIntakePrototype) {
        return
      }

      if (flags.showBillingScheduleHome) {
        navigate(
          `/billing-schedules/${extractionResult.contract.billingScheduleId}/edit?${AUTO_DISPLAY_CONTRACT_ATTACHMENT_QUERY_PARAM_KEY}=true`
        )
        return
      }

      navigate(
        `/billing-schedules/${extractionResult.contract.billingScheduleId}?${AUTO_DISPLAY_CONTRACT_ATTACHMENT_QUERY_PARAM_KEY}=true`
      )
    }, [extractionResult, navigate, flags])
  }
